import { createTokenHeader } from '../utils/functions/headers';
import { emptySplitApi } from './emptySplitApi';

export const CatalogueService =
  emptySplitApi.injectEndpoints({
    endpoints: (build) => ({
      catalogueExport: build.mutation({
        query: (data) => ({
          url: `mycatalog/export`,
          method: 'POST',
          data: data,
        }),
      }),
      bulkAddToCatalogue: build.mutation({
        query: ({ data, plantCode, enterprise }) => ({
          url: `mycatalog/import/${plantCode}/${enterprise}`,
          method: 'POST',
          data: data,
          headers: createTokenHeader(),
        }),
      }),
      addProductsToMyCatalog: build.mutation({
        query: (data) => ({
          url: `mycatalog/add`,
          method: 'POST',
          data: data,
        }),
      }),
    }),
  });

export const {
  useCatalogueExportMutation,
  useBulkAddToCatalogueMutation,
  useAddProductsToMyCatalogMutation,
} = CatalogueService;
